<template>
    <div class="page questions-page">
        <v-container class="py-0 py-lg-6" :class="{'px-0': phoneOnly}">
            <transition name="fade-transition">
                <new-question v-if="loadedData" :categories_select_items="loadedData.categories_select_items" />
            </transition>
        </v-container>
    </div>
</template>

<script>
// @ is an alias to /src

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import NewQuestion from './NewQuestion'

export default {
    name: "",
    components: {
        NewQuestion
    },
    data(){
        return {
            loading: false,
            loadedData: null,
        }
    },
    computed: {
        ...GlobalComputed,
    },
    methods: {
        ...GlobalMethods,
        loadData(){
            if (!this.loading){
                this.loading = true;

                window.axios.get('/exams/questions/create').then(response=>{
                    this.loadedData = response.data;
                    this.loading = false;
                }).catch((e)=>{
                    this.loading = false;
                    if (e && e.response && e.response.status === 404){
                        // this.$router.push('/not-found');
                        this.showMsg('لم يتم العثور على نتيجة');
                    }else{
                        this.showMsg('حدثت مشكلة أثناء تحميل البيانات');
                    }
                });
            }
        },
    },
    watch: {
        loading(loading){
            this.setLinearLoading(loading);
        }
    },
    created(){
        
    },
    mounted(){
        this.loadData();
    }
};
</script>
<style lang="scss" scoped>

</style>
